<template>
  <div class="ourBox">
    <!--    这里是右侧任务分配-->
    <div class="assignedBox" @click="closeMenu">
      <div class="topSearch">
        <top_search_auto
          @openSearchDetial="openSearchDetial"
        ></top_search_auto>
      </div>
      <div style="display: flex">
        <div class="drapBox">
          <div class="topChoose">
            <div class="title" @click="changeAssignList(1)" :class="activeTitlfe == 1? 'active' :''">
              Unassigned
<!--              <div class="point" v-if="is_points == 1"></div>-->
            </div>
            <div class="line"></div>
            <div class="title" @click="changeAssignList(2)" :class="activeTitlfe == 2? 'active' :''">
              Auto-assigned
            </div>
          </div>
          <!--          未分配的任务-->
          <div class="innerTask" v-if="activeTitlfe == 1">
                <div class="innerList unassign">
                  <unassigned_task
                            ref="unassigned_task"
                            @dropStartNewTask="dropStartNewTask"
                            @dropCompleted="dropCompleted"
                            @rightClick="rightClick"
                            v-on="$listeners"
                            v-bind="$attrs"
                  ></unassigned_task>
                </div>
          </div>
          <!--          自动分配任务-->
          <div class="autoTaskList" v-if="activeTitlfe == 2">
            <div class="littleTltle">Only incompleted tasks are listed here</div>
            <div class="empty">No more tasks</div>
          </div>
        </div>
        <div class="dropBox">
          <div style="margin-bottom: 16px;font-size: 14px;text-align: left">Drivers</div>
          <me-tree
            :isExpand="false"
            :showBorder = 'false'
            :newTask="newTask"
            ref="tree_data"
            @dropNewTaskCompleted="dropNewTaskCompleted"
            @dropStartMeTree="dropStartMeTree"
            :dropLeaveTreeTask="dropLeaveTreeTask"
            @dropMeTreeCompleted="dropMeTreeCompleted"
            @rightClicks="rightClicks"
            @rightCliksDriver ='rightCliksDriver'
            v-on="$listeners"
          ></me-tree>
        </div>
      </div>
    </div>
    <div>
      <div>
        <div class="driver-menu-layer" v-if="taskMenu.task" @click="taskMenu.task = null">
          <div class="driver-menu" :style="{left:taskMenu.x+'px',top:taskMenu.y+'px'}">
            <ul class="contextmenu" v-if="taskMenu.taskType =='driver'">
              <li @click="showDetialDrover(taskMenu.task)">
                <img src="@/assets/diapatch/edit/view@2x.png" alt="">
                View driver
              </li>
              <li  @click="clickHandle(taskMenu.task)">
                <img src="@/assets/diapatch/edit/target@2x.png" alt="">
                Show on map
              </li>
            </ul>
            <ul  class="contextmenu" v-else>
              <li @click="showDetial(taskMenu.task)">
                <img src="@/assets/diapatch/edit/view@2x.png" alt="">
                View task
              </li>
              <li  @click="clickHandle(taskMenu.task)">
                <img src="@/assets/diapatch/edit/target@2x.png" alt="">
                Show on map
              </li>
              <li v-if="taskMenu.task.status == 1" @click="openDeleteDialog(taskMenu.task,taskMenu.taskType,1)">
                <img src="@/assets/diapatch/edit/cancel@2x.png" alt="">
                Unassign task
              </li>
              <li @click="openDeleteDialog(taskMenu.task,taskMenu.taskType,0)" v-if="taskMenu.task.status != 2 || taskMenu.taskType !='driver'">
                <img src="@/assets/diapatch/edit/delete@2x.png" alt="">
                Delete task
              </li>
            </ul>
          </div>
        </div>
        <!--  详情dialog-->
        <el-dialog
          :close-on-click-modal="false"
          :modal="false"
          custom-class="right"
          title="Task Details"
          :visible.sync="detialDialog"
          width="30%">
          <task-detial :info="info" ref="taskDetialRef" @closeDailog="closeTaskDetial"></task-detial>
        </el-dialog>
      </div>
      <!--  删除或者unassinged-->
      <el-dialog
        :close-on-click-modal="false"
        :title="deleteTitle"
        :visible.sync="deleteDialog"
        width="30%">
        <div v-if="task_delete_type == 0" class="delete_msg">Will you delete task {{task_invoice_number}}?</div>
        <div  v-if="task_delete_type == 1" class="delete_msg">Will you move task {{task_invoice_number}} to unassigned list?</div>
        <span slot="footer" class="dialog-footer">
<!--    <el-button type="primary" plain >Cancel</el-button>-->
         <el-button type="danger"  @click="deleteDialog = false" plain>No</el-button>
          <el-button type="primary" round @click="confirmDelete">Yes</el-button>
        </span>
      </el-dialog>

      <!--  司机详情dialog-->
      <el-dialog
        :close-on-click-modal="false"
        :visible.sync="driverDdetialDialog"
        width="30%">
        <div class="driver_detial">
          <div class="driver_image">
            <img :src="'https://work.back.rapidi.ca/'+this.driver_detial_data.avatar" alt="">
          </div>
          <div class="driver_name">{{this.driver_detial_data.name}}</div>
          <div>
            <div class="inner_message">
              <div class="inner_title">Created at:</div>
              <div>{{this.driver_detial_data.time}}</div>
            </div>
            <div class="inner_message">
              <div class="inner_title">Device:</div>
              <div>{{this.driver_detial_data.system}}</div>
            </div>
            <div class="inner_message">
              <div class="inner_title">APP Version:</div>
              <div>{{this.driver_detial_data.app_version}}</div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>

  </div>
</template>

<script>
import drag_tree_handle from "@/view/dispatch_test/drag_tree/drag_tree_js/drag_tree_handle";
export default drag_tree_handle;
</script>

<style scoped lang="less">
@import "drag_tree";
</style>
<style lang="less">
.driver_detial{
  width: 310px;
  margin: 0 auto;
  text-align: center;
  .driver_image{
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin: 16px auto;
    img{
      width: 100%;
      height: 100%;
      border-radius: 50%;
      margin: 0 auto;
    }
  }
  .driver_name{
    height: 20px;
    font-size: 14px;
    font-family: SFPro-Bold, SFPro;
    font-weight: bold;
    color: #1F2D42;
    line-height: 20px;
  }
  .inner_message{
    display: flex;
    margin: 8px 0;

    font-size: 14px;
    font-family: SFPro-Regular, SFPro;
    font-weight: 400;
    color: #1F2D42;
    line-height: 20px;

    .inner_title{
      width: 90px;
      margin-right: 8px;
      text-align: right;
    }
  }

}
.driver-menu-layer {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0);
  z-index: 9999;
}

.driver-menu {
  position: fixed;

}
.tips {
  height: 14px;
  font-size: 12px;
  font-family: SFPro-Regular, SFPro;
  font-weight: 400;
  color: #999999;
  line-height: 14px;
}

.el-tree-node > .el-tree-node__children {
  /*overflow: revert !important;*/
}


.left-drop-area {
  min-height: 60px;
  /*底部留一个padding,防止拖动元素时拖不到列表末尾*/
  padding-bottom: 12px;
  cursor: pointer;
}
</style>
